"use client";

import { c as _c } from "react/compiler-runtime";
import { env } from "~/setup/env";
import type { JobadComponentProps } from "~/types/job";
export default function CompanyMjp(t0) {
  const $ = _c(8);
  const {
    job
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      backgroundImage: `url(${env.NEXT_PUBLIC_ASSET_URL}images/jobad/company-bg.webp)`,
      backgroundSize: "cover",
      backgroundPosition: "right"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== job.data.company) {
    t2 = <h2 className="mb-10 font-bold text-4xl md:text-5xl print:text-lg">{job.data.company}</h2>;
    $[1] = job.data.company;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== job.content.business) {
    t3 = <div className="gap-20 text-lg md:columns-2 [&>p]:mb-4" dangerouslySetInnerHTML={{
      __html: job.content.business
    }} data-source="job" />;
    $[3] = job.content.business;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <section className="bg-[#0f738A] px-6 py-10 text-white md:px-10 md:py-20 print:hidden" id="company" style={t1}><div className="mx-auto flex max-w-screen-xl flex-wrap"><div>{t2}{t3}</div></div></section>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}